import { render, staticRenderFns } from "./ToolbarOff.vue?vue&type=template&id=3931e005&"
import script from "./ToolbarOff.vue?vue&type=script&lang=js&"
export * from "./ToolbarOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports